import styled from 'styled-components';

export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 24px;
  max-width: 900px;

  img {
    width: 400px;
    max-width: 900px;
    margin: 0 20px 20px 0;
  }
`;

export const Container = styled.div`
  max-width: 1350px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing(3)};
`;


export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ContentContainer = styled.main`
  flex: 1;
  padding: ${({ theme }) => theme.spacing(3)};
`;

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const FlexContainer = styled.div<{ direction?: 'row' | 'column'; align?: string; justify?: string }>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: ${({ align }) => align || 'stretch'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
`;